import { useTranslation } from 'react-i18next'

import clsx from 'clsx'
import { observer } from 'mobx-react-lite'

import { SearchParams } from 'pages/excursions/search/components/header/components/search-params/search-params'

import findTicketStore from 'entities/beket/models/find-ticket/find-ticket-store.ts'

import { DATE_FORMAT_LIST } from 'shared/constants/dateFormatList.ts'
import { dateFormat } from 'shared/lib/dateFormat.ts'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'

import s from './styles.module.scss'

interface Props {
  onClick?: () => void
  onGoBack: () => void
}

export const BeketHeader = observer(({ onClick, onGoBack }: Props) => {
  const { t } = useTranslation()

  const { directions } = findTicketStore.formFindTicket
  const passengersCount = findTicketStore.getCountOfPassengers()

  const firstDirection = directions[0]
  const directionTitle = `${firstDirection?.from?.cityName} - ${firstDirection?.to?.cityName}`
  let directionText = ''

  if (firstDirection?.date) {
    directionText = `${dateFormat(firstDirection?.date, DATE_FORMAT_LIST.DATE_MONTH)} • ${passengersCount} ${t('pass')}`
  }

  return (
    <div className={clsx('safe-area-top-padding', s.headerWrapper)}>
      <div className={s.header}>
        <AppIcon
          width={24}
          height={24}
          onClick={onGoBack}
          className={s.icon}
          id={AllIcons.ARROW_LEFT}
        />

        <SearchParams
          onShowForm={onClick}
          textDirection={directionText}
          direction={directionTitle}
        />
      </div>
    </div>
  )
})
